import { Link } from 'react-router-dom';
import SeoHead from '../components/SeoHead';
import GalleryLightbox from '../components/GalleryLightbox';
import { imageUrl } from '../lib/images';

export default function IgloFancyPage() {
  const fancyPdf = 'https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/joca-produktblad-overjordisk-fancy.pdf';
  const jocaPdf = 'https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/joca-produktblad-iglo-joca.pdf';
  const vedligeholdPdf = 'https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/vedligehold-overflader.pdf';

  return (
    <>
      <SeoHead
        title="Iglo & fancy - RB Glasfiber A/S"
        description="Download datablad. Fancy sætter brugervenlighed i højsædet. Model joca er den velkendte iglo med profilering via hærværkssikrede indstøbninger."
        canonical="https://www.rb-glasfiber.dk/produkter/iglo-amp-fancy"
        ogImage="https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/rb-glasfiber-fancy-kontainer-cropresize-412x619.webp"
      />

      {/* Hero Header */}
      <section className="relative pt-32 pb-16 lg:pt-40 lg:pb-24 bg-slate-950 text-white overflow-hidden border-b border-slate-800">
        <div className="absolute inset-0 z-0">
          <img
            src={imageUrl('https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/rb-glasfiber-joca-iglo-cropresize-412x619.webp', 'width=1600,quality=80,format=auto')}
            alt="Iglo og Fancy containere"
            className="w-full h-full object-cover opacity-25"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/80 to-slate-950/60" />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded bg-[#1e9457]/20 border border-[#1e9457]/40 text-[#22c55e] text-xs font-bold uppercase tracking-widest mb-4">
              <i className="fa-solid fa-recycle"></i>
              <span>Genanvendelse & Kildesortering</span>
            </div>
            <h1 className="text-3xl sm:text-5xl font-extrabold uppercase tracking-tight text-white mb-6">
              Iglo & fancy
            </h1>
            <p className="text-base sm:text-lg text-slate-300 leading-relaxed max-w-2xl">
              Model joca er den velkendte genbrugsiglo med mulighed for individuelle, hærværkssikrede indstøbninger. Model Fancy tilbyder gennemtænkt brugervenlighed hvor pladsen er trang.
            </p>

            <div className="mt-8 flex flex-wrap items-center gap-4">
              <a
                href={jocaPdf}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2.5 px-6 py-3.5 rounded bg-[#1e9457] hover:bg-[#15703f] text-white font-bold uppercase tracking-wider text-sm shadow transition-all"
              >
                <i className="fa-solid fa-file-pdf"></i>
                <span>Joca datablad (PDF)</span>
              </a>
              <a
                href={fancyPdf}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2.5 px-6 py-3.5 rounded bg-slate-800 hover:bg-slate-700 text-white font-semibold text-sm border border-slate-700 transition-all"
              >
                <i className="fa-solid fa-file-pdf"></i>
                <span>Fancy datablad (PDF)</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-20">
          {/* Section 1: Fancy (anchor185) */}
          <div id="anchor185" className="scroll-mt-32 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            <div className="lg:col-span-7 space-y-6">
              <div className="inline-flex items-center gap-2 text-xs font-bold text-[#1e9457] uppercase tracking-wider">
                <span className="w-2 h-2 rounded-full bg-[#1e9457]"></span>
                Model Fancy
              </div>
              <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 uppercase">
                Fancy: Gennemtænkt brugervenlighed
              </h2>
              <div className="prose text-slate-700 text-base leading-relaxed space-y-4">
                <p>
                  Fancy sætter brugervenlig i højsædet. Den kan anvendes hvor adgangsforhold ikke tillader placering af igloer, eller hvor der er brug for mindre kapacitet. Læg dertil at Fancy kan leveres på hjul, og du har en optimal løsning.
                </p>
              </div>

              {/* Teknisk data Fancy */}
              <div className="p-6 rounded-lg bg-slate-50 border border-slate-200">
                <h3 className="font-bold text-slate-900 uppercase text-sm mb-3">Teknisk data - Fancy</h3>
                <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm text-slate-700">
                  <li className="flex items-center gap-2"><i className="fa-solid fa-check text-[#1e9457]"></i><span>Fremstillet i glasfiber</span></li>
                  <li className="flex items-center gap-2"><i className="fa-solid fa-check text-[#1e9457]"></i><span>Størrelse: 700 l</span></li>
                  <li className="flex items-center gap-2"><i className="fa-solid fa-check text-[#1e9457]"></i><span>Alt jern er galvaniseret</span></li>
                  <li className="flex items-center gap-2"><i className="fa-solid fa-check text-[#1e9457]"></i><span>Ekstra forstærket ved top og bund</span></li>
                  <li className="flex items-center gap-2"><i className="fa-solid fa-check text-[#1e9457]"></i><span>Højde til indkast er 145 cm</span></li>
                  <li className="flex items-center gap-2"><i className="fa-solid fa-check text-[#1e9457]"></i><span>Hjul: standard 160 mm. hjul med bremse</span></li>
                  <li className="flex items-center gap-2"><i className="fa-solid fa-check text-[#1e9457]"></i><span>Selvlukkende papirindkast</span></li>
                  <li className="flex items-center gap-2"><i className="fa-solid fa-check text-[#1e9457]"></i><span>Minimal skårprocent</span></li>
                </ul>
              </div>

              <div className="pt-2">
                <a
                  href={fancyPdf}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-sm font-bold text-[#1e9457] hover:underline"
                >
                  <i className="fa-solid fa-file-pdf"></i>
                  <span>Download Fancy datablad</span>
                </a>
              </div>
            </div>

            <div className="lg:col-span-5">
              <div className="rounded-xl overflow-hidden border border-slate-200 shadow-md aspect-[3/4] bg-slate-900 max-w-sm mx-auto">
                <img
                  src={imageUrl('https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/rb-glasfiber-fancy-kontainer-cropresize-412x619.webp', 'width=600,quality=85,format=auto')}
                  alt="Fancy container"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>

          <hr className="border-slate-200" />

          {/* Section 2: Joca Igloer (anchor186) */}
          <div id="anchor186" className="scroll-mt-32 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            <div className="lg:col-span-5 order-2 lg:order-1">
              <div className="rounded-xl overflow-hidden border border-slate-200 shadow-md aspect-[3/4] bg-slate-900 max-w-sm mx-auto">
                <img
                  src={imageUrl('https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/rb-glasfiber-joca-iglo-cropresize-412x619.webp', 'width=600,quality=85,format=auto')}
                  alt="Joca iglo"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            <div className="lg:col-span-7 order-1 lg:order-2 space-y-6">
              <div className="inline-flex items-center gap-2 text-xs font-bold text-[#1e9457] uppercase tracking-wider">
                <span className="w-2 h-2 rounded-full bg-[#1e9457]"></span>
                Model Joca
              </div>
              <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 uppercase">
                Joca igloer: Den velkendte iglo
              </h2>
              <div className="prose text-slate-700 text-base leading-relaxed space-y-4">
                <p>
                  Model joca er den velkendte iglo, der med sin prægnante form, er blevet et symbol på genanvendelse af flasker og papir. Model joca giver en ideel mulighed for profilering via hærværkssikrede indstøbninger og vi har gennem årene leveret denne iglo med et utal af indstøbninger – kun fantasien sætter grænser.
                </p>
              </div>

              {/* Teknisk data Joca */}
              <div className="p-6 rounded-lg bg-slate-50 border border-slate-200">
                <h3 className="font-bold text-slate-900 uppercase text-sm mb-3">Teknisk data - Joca igloer</h3>
                <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm text-slate-700">
                  <li className="flex items-center gap-2"><i className="fa-solid fa-check text-[#1e9457]"></i><span>Fremstillet i glasfiber</span></li>
                  <li className="flex items-center gap-2"><i className="fa-solid fa-check text-[#1e9457]"></i><span>Størrelse: 1,5m³ og 2,5m³</span></li>
                  <li className="flex items-center gap-2"><i className="fa-solid fa-check text-[#1e9457]"></i><span>Farve efter ønske</span></li>
                  <li className="flex items-center gap-2"><i className="fa-solid fa-check text-[#1e9457]"></i><span>Bund opbygget som kegle</span></li>
                  <li className="flex items-center gap-2"><i className="fa-solid fa-check text-[#1e9457]"></i><span>2 eller 3 indkast</span></li>
                  <li className="flex items-center gap-2"><i className="fa-solid fa-check text-[#1e9457]"></i><span>2 muligheder for papirindkast</span></li>
                  <li className="flex items-center gap-2"><i className="fa-solid fa-check text-[#1e9457]"></i><span>Mulighed for folie</span></li>
                  <li className="flex items-center gap-2"><i className="fa-solid fa-check text-[#1e9457]"></i><span>Alt jern er galvaniseret</span></li>
                  <li className="flex items-center gap-2"><i className="fa-solid fa-check text-[#1e9457]"></i><span>Minimal skårprocent</span></li>
                  <li className="flex items-center gap-2"><i className="fa-solid fa-check text-[#1e9457]"></i><span>Glatpoleret overflade i flot finish</span></li>
                </ul>
              </div>

              <div className="pt-2">
                <a
                  href={jocaPdf}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-sm font-bold text-[#1e9457] hover:underline"
                >
                  <i className="fa-solid fa-file-pdf"></i>
                  <span>Download Joca iglo datablad</span>
                </a>
              </div>
            </div>
          </div>

          <hr className="border-slate-200" />

          {/* Section 3: Klæbemærker (anchor187) */}
          <div id="anchor187" className="scroll-mt-32 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            <div className="lg:col-span-7 space-y-6">
              <div className="inline-flex items-center gap-2 text-xs font-bold text-[#1e9457] uppercase tracking-wider">
                <span className="w-2 h-2 rounded-full bg-[#1e9457]"></span>
                Profilering & Identitet
              </div>
              <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 uppercase">
                Klæbemærker: Mulighed for individuelt design
              </h2>
              <div className="prose text-slate-700 text-base leading-relaxed space-y-4">
                <p>
                  RB Glasfiber kan skabe en individuel iglo, der svarer til dine ønsker:
                </p>
                <ul className="space-y-2 list-none pl-0">
                  <li className="flex items-start gap-3">
                    <span className="w-6 h-6 rounded-full bg-[#1e9457]/10 text-[#1e9457] font-bold text-xs flex items-center justify-center flex-shrink-0 mt-0.5">1</span>
                    <span>Du aftaler med os, hvordan du ønsker, din iglo skal se ud.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="w-6 h-6 rounded-full bg-[#1e9457]/10 text-[#1e9457] font-bold text-xs flex items-center justify-center flex-shrink-0 mt-0.5">2</span>
                    <span>Du kan ønske dig et byvåben, et logo eller noget andet.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="w-6 h-6 rounded-full bg-[#1e9457]/10 text-[#1e9457] font-bold text-xs flex items-center justify-center flex-shrink-0 mt-0.5">3</span>
                    <span>Vi er naturligvis altid behjælpelig med ideer både til illustrationer og farver.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="w-6 h-6 rounded-full bg-[#1e9457]/10 text-[#1e9457] font-bold text-xs flex items-center justify-center flex-shrink-0 mt-0.5">4</span>
                    <span>Vi kommer og præsenterer dig for et udkast.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="w-6 h-6 rounded-full bg-[#1e9457]/10 text-[#1e9457] font-bold text-xs flex items-center justify-center flex-shrink-0 mt-0.5">5</span>
                    <span>Efter præsentation rettes og færdiggøres udkastet.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="w-6 h-6 rounded-full bg-[#1e9457]/10 text-[#1e9457] font-bold text-xs flex items-center justify-center flex-shrink-0 mt-0.5">6</span>
                    <span>Vi foreviser endelig korrektur og layout, som herefter går til produktion.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="w-6 h-6 rounded-full bg-[#1e9457]/10 text-[#1e9457] font-bold text-xs flex items-center justify-center flex-shrink-0 mt-0.5">7</span>
                    <span>Efter fremstilling af afdækningsmaterialet går igloen i produktion på støbefabrikken.</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="lg:col-span-5">
              <div className="rounded-xl overflow-hidden border border-slate-200 shadow-md aspect-[3/4] bg-slate-900 max-w-sm mx-auto">
                <img
                  src={imageUrl('https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/rb-glasfiber-indstoebninger-glasfiber-cropresize-412x619.webp', 'width=600,quality=85,format=auto')}
                  alt="Klæbemærker og hærværkssikrede indstøbninger"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>

          {/* Lightbox Gallery */}
          <div className="pt-8 border-t border-slate-200">
            <GalleryLightbox
              gallerySlug="standardprodukter"
              title="Fotogalleri: Igloer & containere"
              description="Se udvalgte billeder af igloer, indstøbninger og affaldsløsninger i praksis."
              columns={3}
            />
          </div>
        </div>
      </section>
    </>
  );
}
